<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from '../../modules/vodafone_lab_mixins_module.js';
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, vodafoneLabBasicMixin],
  props: {
    width: {
      type: Number,
      default: 7
    }
  },
  data: function () {
    return {};
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : this.width;
      return [
        `col-lg-${columnWidth}`,
        `text-${this.content.text_align}`
      ];
    },
  },
  methods: {
    expandUrl: Fandom.expandUrl,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTarget: Fandom.getTarget,
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType"
    class="py-4 py-md-5"
    v-if="isContentVisibleToUser()" 
    list-keyopints-simple-component
    :id="content.name"
  >
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <stripe-header :content="content" v-if="content.title || content.description"></stripe-header>
    <div class="container">
      <div class="row mt-4 mt-md-5 justify-content-center">
        <div class="col-12" :class="columnClasses">
          <div class="row" v-if="content.keypoints.length > 0">
            <div class="col-12 d-flex align-items-center" :class="`col-md-${parseInt(content.column_count) == 2 ? 6 : 12}`" v-for="(point, index) in content.keypoints" :key="index">
              <div class="icon-wrapper pr-4">
                <img class="img-fluid" :src="point.icon.url" v-if="point.icon" >
              </div>
              <div class="text-wrapper text-left pl-2">
                <span class="h6 font-weight-bold" v-html="point.title"></span>
                <p class="small">{{point.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-4 mt-md-5" v-if="content.evaluation_tool" >
      <evaluation-tool-trigger
        :text="content.evaluation_tool.button_text"
        :content="getContent(content.evaluation_tool.content)"
        :btnClass="getPrimaryButtonClass(content.evaluation_tool.button_class, content.theme)"
      ></evaluation-tool-trigger>
    </div>
  </div>
</template>

<style lang="scss">
[list-keyopints-simple-component] {
  .icon-wrapper {
    min-width: 6rem;
  }
}

</style>